<style lang="scss" scoped>
.home {
	&__search {
		margin-bottom: 30px;
	}
	&__promotion {
		margin-bottom: 30px;
	}
}
</style>

<template lang="pug">
    layout-page.home
        promotion.home__promotion
        search-bar.home__search
        applications.home__applications
</template>

<script>
import SearchBar from "./includes/SearchBar";
import Applications from "./includes/Applications";
import Promotion from "./includes/Promotion";

export default {
	components: {
		SearchBar,
		Applications,
		Promotion
	}
};
</script>


